import { getToken } from '../../../utils/common';
import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  getV1Company,
} from "../../../api-client/api.rbac/api";
import { getV1AssemblyItems, getV1InventoryItems, getV1WarehouseLocation } from "../../../api-client/api.inventory/api";
import { getV1BillsOfMaterials } from "../../../api-client/api.manufacturing/api";



export const fetchOptions = createAsyncThunk(
  "reports-title/fetchOptions",
  async () => {
    const i = await handleFetchItem();
    const c = await handleFetchCompanies();
    const wl = await handleFetchWarehouseLocations();
    const ai = await fetchAssemblyItems();
    return { i, c, wl, ai };
  }
);
export const fetchBom = createAsyncThunk(
  "reports-title/fetchBom",
  async () => {
    const bom = await fetchBomData();
    return bom
  }
);

export const handleFetchCompanies = async () => {
  try {
    const response = await getV1Company({ ...getToken() });

    return response?.data?.company
  } catch (error) {
    return [];
  }
};

export const handleFetchItem = async () => {
  try {
    const response = await getV1InventoryItems({
      ...getToken(),
      skip: 0,
      limit: 999,
      filters: `(type.eq=inventory|type.eq=assembly&is_variant.eq=false|self_variant.eq=true)`,
    });

    return response?.data?.inventoryItemsList
  } catch (error) {
    return [];
  }
};

export const handleFetchWarehouseLocations = async () => {
  try {
    const response = await getV1WarehouseLocation({
      ...getToken(),
      skip: 0,
      limit: 999,
    });


    return response?.data?.warehouseLocationList
  } catch (error) {
    return [];
  }
};


export const fetchAssemblyItems = async () => {
  try {
    const response: any = await getV1AssemblyItems({
      ...getToken(),
      skip: 0,
      limit: 999,
    }
    )
    return response?.data?.assemblyItemsList
  } catch (error: any) {
    return []
  }
}

const fetchBomData = async () => {
  try {
    const response: any = await getV1BillsOfMaterials({
      skip: 0,
      limit: 99999,
      ...getToken()
    })

    return response?.data?.bom_list
  } catch (error) {
    return []
  }
}